import { Button, Form, FormInstance, Row } from "antd";
import { useCallback } from "react";

type FooterProps = {
  form: FormInstance;
  id: string | undefined | null;
  isSaving: boolean;
  save: (isAddNew: boolean) => void;
  close: () => void;
};

export const Footer = ({ form, id, isSaving, save, close }: FooterProps) => {
  const confirm = Form.useWatch("confirmation", form);

  const onAdd = useCallback(() => save(false), [save]);

  const onAddNew = useCallback(() => save(true), [save]);

  return (
    <Row className="divider pa-6">
      {!id && (
        <>
          <Button
            shape="round"
            type="primary"
            className="mr-4"
            disabled={isSaving || !confirm}
            loading={isSaving}
            onClick={onAdd}
          >
            Add
          </Button>
          <Button
            shape="round"
            className="mr-4"
            disabled={isSaving || !confirm}
            loading={isSaving}
            onClick={onAddNew}
          >
            Add & New
          </Button>
        </>
      )}
      <Button shape="round" disabled={isSaving} onClick={close}>
        Close
      </Button>
    </Row>
  );
};
